import '@styles/pages/seller-page-space.scss';

import { initCarousel } from '@molecules/carousel';
import { initStaticGoogleMap } from '@molecules/static-google-map';
import { initGallery } from '@organisms/gallery';
import { initVirtualvisit } from '@organisms/virtualvisit';
import { initSpaceDetails } from './seller-page-space/space-details';

initCarousel();
initSpaceDetails();
initStaticGoogleMap();
initVirtualvisit();
initGallery();
